import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RegisterModal from "../component/RegisterModal";

const EnrollmentPage = ({
  isFromProfile = false,
  closeTo = "/",
  successTo = "/dashboard",
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pageState = location.state || {};
  const selectedCourseId = pageState.selectedCourseId
    ? String(pageState.selectedCourseId)
    : "";
  const resolvedCloseTo = pageState.closeTo || closeTo;
  const resolvedSuccessTo = pageState.successTo || successTo;
  const pageTitle = "Complete Your Course Enrollment";
  const pageSubtitle =
    "Choose your course, compare driving schools, and lock in your training schedule from a single responsive enrollment page.";

  return (
    <>
      <style>{`
        .enroll-page-shell {
          min-height: 100vh;
          padding: 14px 12px;
          background:
            radial-gradient(circle at top right, rgba(13, 110, 253, 0.12), transparent 34%),
            radial-gradient(circle at bottom left, rgba(25, 135, 84, 0.1), transparent 28%),
            linear-gradient(180deg, #f7fbff 0%, #eef5ff 48%, #ffffff 100%);
        }
        .enroll-page-grid {
          max-width: 1180px;
          margin: 0 auto;
          display: block;
        }
        .enroll-page-main {
          min-width: 0;
        }
        .enroll-page-topbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          margin-bottom: 10px;
          flex-wrap: wrap;
        }
        .enroll-page-kicker {
          margin: 0;
          font-size: 0.9rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #0d6efd;
        }
        .enroll-page-back {
          border: 0;
          background: #edf4ff;
          color: #0d6efd;
          border-radius: 999px;
          padding: 8px 14px;
          font-size: 0.9rem;
          font-weight: 600;
        }
        .enroll-page-back:hover {
          background: #dbe8ff;
        }
        .enroll-page-embedded .modal-overlay {
          position: static;
          inset: auto;
          width: auto;
          height: auto;
          padding: 0;
          background: transparent;
          overflow: visible;
          display: block;
        }
        .enroll-page-embedded .modal-box {
          width: 100%;
          max-width: 100% !important;
          margin: 0;
          border-radius: 24px;
          padding: 20px;
          box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
        }
        .enroll-page-embedded .modal-box::before {
          opacity: 0.08;
        }
        .enroll-page-embedded .registerclose {
          display: none;
        }
        @media (max-width: 768px) {
          .enroll-page-shell {
            padding: 12px 10px;
          }
          .enroll-page-embedded .modal-box {
            padding: 16px;
          }
        }
        @media (max-width: 576px) {
          .enroll-page-embedded .modal-box {
            padding: 16px;
            border-radius: 20px;
          }
        }
      `}</style>

      <div className="enroll-page-shell">
        <div className="enroll-page-grid">
          <div className="enroll-page-main">
            <div className="enroll-page-topbar">
              <p className="enroll-page-kicker">Enrollment Portal</p>
              <button
                type="button"
                className="enroll-page-back"
                onClick={() => navigate(resolvedCloseTo)}
              >
                Back
              </button>
            </div>
            <div className="enroll-page-embedded">
              <RegisterModal
                show={true}
                onClose={() => navigate(resolvedCloseTo)}
                onLoginClick={() => navigate("/login")}
                isFromProfile={isFromProfile}
                initialCourseId={selectedCourseId}
                lockBodyScroll={false}
                enrollHeading={pageTitle}
                enrollDescription={pageSubtitle}
                onEnrollSuccess={() => navigate(resolvedSuccessTo)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnrollmentPage;
